import type { ReactNode } from 'react';
import React from 'react';

import { Col, Row, Typography } from 'antd';

import type { TestProps } from '/imports/ui/components/shared';

export interface MainContentProps extends TestProps {
  title: ReactNode;
  extra?: ReactNode;
  /** This is an escape hatch: only use in dire situations. */
  style?: React.CSSProperties;
}

export const MainContent = ({
  title,
  extra = null,
  style = {},
  'data-testid': dataTestId,
  children,
}: React.PropsWithChildren<MainContentProps>) => (
  <div
    style={{ padding: '16px 24px', ...style }}
    {...(dataTestId == null ? undefined : { 'data-testid': dataTestId })}
  >
    <Row justify="space-between">
      <Col
        style={{
          display: 'flex',
          alignItems: 'center',
          lineHeight: 1.5715,
          margin: '4px 0',
        }}
      >
        <Typography.Title
          data-test="main-content-title"
          style={{
            marginRight: 12,
            marginBottom: 0,
            fontSize: 20,
            lineHeight: '32px',
          }}
        >
          {title}
        </Typography.Title>
      </Col>
      <Col style={{ lineHeight: 1.5715, margin: '4px 0', whiteSpace: 'nowrap' }}>{extra}</Col>
    </Row>
    <div data-test="main-content" style={{ paddingTop: 12 }}>
      {children}
    </div>
  </div>
);
